var map = {
	"./Arabic.json": 46349,
	"./Chinese.json": 42248,
	"./English.json": 2019,
	"./French.json": 29241,
	"./Indonesian.json": 61937,
	"./Portuguese.json": 29820,
	"./Spanish.json": 57867,
	"./Turkish.json": 77443,
	"./Vietnamese.json": 78966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52776;